module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/~/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = 491
// module chunks = 4